// i18n area 'system' — locale es-ES (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.es-ES.meta.json.
// DA RIVEDERE DA MADRELINGUA (F7 rinviata): rinomina F1 archivio→«copia de configuración» (#247).
import type { enUS } from './system'

export const esES: typeof enUS = {
  diagnostics: {
    title: 'Diagnóstico',
    subtitle: 'Qué va mal, lo peor primero — la misma lente que tvirt diagnose',
    reload: 'Recargar',
    loadError: 'No se pudo leer el diagnóstico',
    exportBundle: 'Exportar el paquete',
    exportError: 'No se pudo generar el paquete',
    noProblem: 'Ningún problema en las áreas inspeccionadas',
    nothingInspected: 'NADA se ha inspeccionado — esto no es un certificado de buena salud',
    inspected: 'Inspeccionadas',
    notInspected: 'NO inspeccionadas',
    localHint: 'Las áreas locales del nodo (unidades systemd, journal) solo se leen desde la CLI: tvirt diagnose --area local — la vía cuando la API no responde.',
    thresholds: 'tareas fallidas en {hours} h, heartbeat con retraso superior a {seconds} s',
    severity: {
      critical: 'Crítico',
      warning: 'Aviso',
      unknown: 'Desconocido'
    }
  },
  explorer: {
    title: 'Explorador de recursos',
    root: 'Raíz',
    empty: 'Ningún recurso en este scope',
    previewHint: 'Seleccione un objeto para ver su vista previa',
    open: 'Abrir',
    openScoped: 'Abrir la lista en este scope',
    kinds: {
      vm: 'VM',
      vmTemplate: 'Template de VM',
      ct: 'CT',
      ctTemplate: 'Template de CT',
      app: 'App',
      overlayNetwork: 'Red overlay',
      networkService: 'Servicio de red',
      fabric: 'Fabric',
      subnet: 'Subnet',
      storage: 'Pool de storage',
      disk: 'Disco',
      catalogFile: 'Archivo de catálogo',
      ociRegistry: 'Registro OCI',
      ociImage: 'Imagen OCI',
      cephCluster: 'Clúster Ceph',
      backupDestination: 'Destino de backup',
      user: 'Usuario',
      group: 'Grupo',
      role: 'Rol',
      credential: 'Credencial',
      tag: 'Tag',
      proximityRule: 'Regla de proximidad'
    }
  },
  tags: {
    title: 'Tags',
    empty: 'Ningún tag',
    add: 'Añadir tag',
    remove: 'Quitar',
    name: 'Tag',
    value: 'Valor',
    save: 'Guardar',
    saveError: 'No se pudieron guardar los tags',
    loadError: 'No se pudo cargar el vocabulario de los tags',
    noVocabulary: 'Ningún tag disponible para este tipo de recurso',
    overwrite: 'Sustituir el valor actual',
    createTitle: 'Crear tag',
    editTitle: 'Editar tag',
    nameHint: 'Letras, cifras, puntos, guiones y guiones bajos — ni ":" ni "/"; el prefijo tvirt- está reservado a la plataforma',
    cardinality: 'Cardinalidad',
    cardinalitySingle: 'Un solo valor',
    cardinalityMultiple: 'Varios valores',
    cardinalityHint: 'Con un solo valor, reasignar el tag pide sustituirlo',
    autoCreate: 'Autocreación de valores',
    autoCreateOn: 'Al asignar',
    autoCreateOff: 'Solo declarados',
    autoCreateHint: 'Activa: asignar un valor nuevo lo crea. Inactiva: solo se asignan los valores declarados',
    values: 'Valores',
    noValues: 'Ningún valor declarado',
    addValue: 'Añadir valor',
    duplicateValue: 'Valor duplicado',
    kinds: 'Tipos de recurso',
    kindsAll: 'Todos',
    kindsPlaceholder: 'Todos',
    kindsHint: 'Deje vacío para admitir cada tipo de recurso taggeable',
    systemChip: 'Sistema',
    deleteCascade: 'Eliminar también las asignaciones',
    deleteCascadeHint: 'Una etiqueta todavía asignada a algún recurso se rechaza: con esta opción los valores y todas las asignaciones se van junto con la etiqueta.'
  },
  scopes: {
    title: 'Scopes',
    createTitle: 'Crear scope',
    editTitle: 'Renombrar scope',
    path: 'Ruta',
    segment: 'Segmento',
    segmentHint: 'Minúsculas, cifras y guiones (DNS-1123)',
    parent: 'Padre',
    rootChip: 'Raíz',
    preview: 'Nuevo scope',
    pickLabel: 'Scope',
    pickHint: 'Dónde vive el objeto en el árbol del clúster — la raíz o un vDC dentro de ella.',
    ociCache: 'Caché OCI (override)',
    appEphemeral: 'Pool efímero de App (override)',
    inherit: 'Heredar',
    inheritsFrom: 'Hereda de',
    inheritsCluster: 'Hereda el default del clúster',
    inheritsNone: 'Hereda — ningún pool efectivo',
    failoverProtection: 'Protección en degradado',
    networkWeight: 'Peso de red',
    networkCeil: 'Techo de red (Mbps)',
    protectionProtected: 'Protegida',
    protectionExpendable: 'Sacrificable en degradado',
    protectionDefault: 'Predeterminado del clúster'
  },
  sysinfo: {
    summary: 'Versiones de la plataforma en el clúster, componentes de cada nodo, manual de administración y licencia.',
    platformTitle: 'Plataforma TVirt',
    platformSubtitle: 'Versiones observadas en los nodos del clúster',
    versionOnNodes: '{version} en {n} nodos',
    versionOnOneNode: '{version} en 1 nodo',
    mixedVersions: 'Más de una versión de la plataforma en el clúster — esperado solo durante una actualización en curso (como mucho dos).',
    tooManyVersions: 'Más de dos versiones de la plataforma en el clúster — nunca es esperado, ni siquiera durante una actualización: revise los nodos aquí abajo.',
    unreportedNodes: 'Aún ningún report de versiones desde: {nodes}',
    noVersionsYet: 'Ningún nodo ha reportado aún sus versiones.',
    nodesUnavailable: 'La lista de nodos no es visible con sus permisos — imposible mostrar las versiones de la plataforma.',
    colNode: 'Nodo',
    manualTitle: 'Manual de administración',
    manualSubtitle: 'Copia local, servida por este clúster',
    manualBody: 'El manual TVirt completo en PDF, servido directamente por la plataforma — disponible también en entornos air-gapped.',
    manualLink: 'Manual de administración (PDF)',
    apiExplorerTitle: 'Explorador de API',
    apiExplorerSubtitle: 'El contrato OpenAPI, navegable',
    apiExplorerBody: 'El contrato OpenAPI completo de la plataforma — cada ruta, esquema y código de respuesta — explorable desde el navegador, servido a través de este nodo.',
    apiExplorerLink: 'Explorar la API',
    kubeTitle: 'Compatibilidad con Kubernetes',
    kubeSubtitle: 'kubectl y sus herramientas, delante de la API nativa',
    kubeBody: 'TVirt KubeCompat proyecta Pods, Deployments, Services, namespaces, nodos y eventos en el dialecto de Kubernetes — solo lectura, más la eliminación de Deployments. Cada llamada pasa por la API nativa con tus permisos: en el kubeconfig usa un app token como bearer.',
    kubeEndpoint: 'Endpoint para kubectl',
    kubeStatusActive: 'Activo — Kubernetes {version}',
    kubeStatusMissing: 'No instalado en este nodo (paquete trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Instalado pero no responde — comprueba la unidad trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Comprobando…'
  },
  licensing: {
    title: 'Licencia del clúster',
    subtitle: 'Licencia por suscripción — como mucho una por clúster',
    absentTitle: 'Ninguna licencia registrada',
    absentBody: 'Sin una licencia válida el clúster rechaza arrancar nuevas máquinas virtuales (las VM encendidas siguen encendidas). Registre el product key recibido con la suscripción.',
    registerButton: 'Registrar licencia',
    removeButton: 'Quitar licencia',
    state: {
      ok: 'Válida',
      limitExceeded: 'Límite superado',
      expired: 'Caducada'
    },
    productKeyLabel: 'Product key',
    basisLabel: 'Base del límite',
    basis: {
      concurrentVms: 'VM encendidas simultáneas',
      physicalCores: 'Cores físicos (total del clúster)'
    },
    limitLabel: 'Límite',
    usageLabel: 'Uso actual',
    usageOf: '{used} de {limit}',
    usagePartial: 'suma parcial — {n} nodo(s) sin topología CPU observada',
    usageUnknown: 'no observable por el momento',
    expiresLabel: 'Caducidad',
    neverExpires: 'nunca',
    registeredLabel: 'Registrada',
    gateNote: 'Con la licencia ausente, caducada o por encima del límite el clúster rechaza arrancar NUEVAS máquinas virtuales. Las VM encendidas siguen encendidas y los reinicios HA no se ven afectados.',
    devStage: 'Fase de desarrollo: el product key se acepta tal cual junto con los límites declarados aquí; la validación con clave firmada llegará en una release futura.',
    dialogTitle: 'Registrar licencia',
    dialogExpiresHelp: 'Vacío = la licencia no caduca nunca',
    dialogSubmit: 'Registrar',
    dialogError: 'No se pudo registrar la licencia.',
    removeTitle: 'Quitar licencia',
    removeBody: 'El clúster quedará SIN LICENCIA: las nuevas máquinas virtuales rechazarán arrancar hasta que registre una. Las VM encendidas siguen encendidas.',
    removeConfirm: 'Quitar',
    removeError: 'No se pudo quitar la licencia.'
  },
  rbac: {
    tabRoles: 'Roles',
    tabGrants: 'Delegaciones',
    rolesTitle: 'Roles',
    createRoleTitle: 'Crear rol',
    editRoleTitle: 'Editar rol',
    nameHint: 'Minúsculas, cifras y guiones; el prefijo tvirt- está reservado',
    systemChip: 'Sistema',
    permissions: 'Permisos',
    permissionsPlaceholder: 'Añadir permiso…',
    includedRoles: 'Roles incluidos',
    includedRolesPlaceholder: 'Añadir rol…',
    grantsTitle: 'Delegaciones',
    createGrantTitle: 'Crear delegación',
    principal: 'Principal',
    principalKind: 'Tipo de principal',
    principalUser: 'Usuario',
    principalGroup: 'Grupo',
    role: 'Rol',
    grantRight: 'Delegación',
    grantRightChip: 'Puede delegar',
    grantRightLabel: 'Con derecho de delegación (el destinatario puede a su vez delegar este rol)',
    effective: 'Efectiva',
    notEffective: 'No efectiva',
    createdAt: 'Creada',
    scopeHint: '/path exacto, /path/* recursivo — las delegaciones se anclan a una raíz montada (/* no es delegable)'
  },
  groups: {
    title: 'Grupos',
    createTitle: 'Crear grupo',
    nameHint: 'Minúsculas, cifras y guiones; único en el scope',
    members: 'Miembros',
    membersTitle: 'Miembros',
    membersPlaceholder: 'Añadir usuario…',
    noMembers: 'Ningún miembro',
    realmMappings: 'Mapeos de realm',
    realmMappingsTitle: 'Mapeos de realm',
    realmMappingsHint: 'A qué corresponde este grupo en cada realm externo. La pertenencia se lee del directory en el momento del acceso: un grupo del directory que nadie mapea aquí se ignora, y el anidamiento no se resuelve — hay que aplanarlo del lado del directory.',
    realm: 'Realm',
    externalGroup: 'Grupo externo',
    addRealmMapping: 'Añadir mapeo',
    removeRealmMapping: 'Quitar mapeo',
    noRealmMappings: 'Ningún mapeo de realm',
    sectionGeneral: 'General',
    mappingsNoRealms: 'Ningún realm externo configurado — la superficie de mapeo se desbloquea en cuanto exista un realm.',
    mappingsNoRealmsLink: 'Abrir el tab Realms y SSO',

    // La obligación de MFA impuesta por el grupo (round #178 mitad B): OR
    // puro — un grupo solo puede AÑADIR la obligación, nunca quitarla.
    mfaRequired: 'Obligación de MFA',
    mfaRequiredChip: 'Impone la MFA',
    mfaNotRequiredChip: 'Sin obligación',
    mfaRequiredHint:
      'OR puro: un grupo puede AÑADIR la obligación del segundo factor a sus miembros — también a las identidades externas, vía mapeos de realm — nunca quitarla. Vale desde el próximo acceso: las sesiones abiertas no se cierran.'
  },
  users: {
    title: 'Usuarios',
    createTitle: 'Crear usuario',
    editTitle: 'Editar usuario',
    username: 'Nombre de usuario',
    usernameHint: 'Minúsculas, cifras, puntos y guiones',
    displayName: 'Nombre mostrado',
    enabled: 'Habilitado',
    state: 'Estado',
    enabledChip: 'Habilitado',
    disabledChip: 'Deshabilitado',
    lockedChip: 'Bloqueado',
    password: 'Contraseña',
    passwordSetChip: 'Establecida',
    mustChangeChip: 'Por cambiar',
    initialPassword: 'Contraseña inicial',
    initialPasswordHint: 'El usuario deberá cambiarla en el primer acceso',
    lastLogin: 'Último acceso',
    neverLoggedIn: 'Nunca ha entrado',
    setPasswordTitle: 'Establecer contraseña',
    setPasswordHint: 'Sustitución administrativa — requiere su contraseña (modo sudo) y obliga al usuario a cambiarla en el próximo acceso.',
    operatorPassword: 'Su contraseña',
    unlock: 'Desbloquear la cuenta',
    revokeTitle: 'Revocar sesiones',
    revokeBody: 'Todas las sesiones activas de este usuario se terminan inmediatamente.',
    revokeIncludeTokens: 'Revocar también los app tokens',
    revokeConfirm: 'Revocar',
    tabAccount: 'Cuenta',
    tabSecurity: 'Seguridad',
    usernameImmutableHint: 'El nombre de usuario es la identidad de la cuenta — fijado en la creación',
    groups: 'Grupos',
    noGroups: 'Ningún grupo',
    mustChangePassword: 'Cambio de contraseña obligatorio',
    failedAttempts: 'Intentos de acceso fallidos',
    lockedUntil: 'Bloqueado hasta',
    tabUsers: 'Usuarios',
    tabGroups: 'Grupos',
    tabRealms: 'Realms y SSO',
    tabMfa: 'MFA',
    mfa: {
      title: 'Segundo factor (MFA)',
      methodsTitle: 'Métodos disponibles',
      methodsSubtitle: 'Lo que esta instalación sabe verificar como segundo factor',
      methodsError: 'No se pudo cargar el registro de métodos',
      builtinChip: 'Integrado',
      enrollableChip: 'Enrollment en TVirt',
      delegatedChip: 'Gestionado externamente',
      state: 'Estado',
      stateActive: 'Activo',
      statePending: 'A la espera de enrollment',
      stateNone: 'Sin enrolar',
      required: 'Obligación de MFA',
      requiredChip: 'Obligatorio',
      notRequiredChip: 'No obligatorio',
      enrolledAt: 'Enrollment del',
      enrolledMethods: 'Métodos enrolados',
      noMethods: 'Sin enrollment',
      codesRemaining: 'Códigos de recuperación restantes',
      resetTitle: 'Restablecer el segundo factor',
      resetHint:
        'El enrollment y todos los códigos de recuperación se borran: en el próximo acceso el usuario repetirá el enrollment desde cero. La obligación de MFA queda como está — un administrador nunca establece un secreto, solo lo borra.',
      resetConfirm: 'Restablecer',
      resetError: 'No se pudo restablecer el segundo factor',
      empty: 'Aún no hay usuarios gestionados — las cuentas aparecen aquí en cuanto existen, cada una con su estado del segundo factor.',

      // Mitad B (round #178): procedencia del veredicto efectivo, enrollments
      // externos con el estado huérfano, grupos que imponen la obligación.
      viaSelf: 'Personal',
      viaSelfHint: 'La contribución personal de la cuenta (su flag) — la única parte que el lápiz modifica.',
      viaGroupHint: 'Obligación heredada de este grupo: quitar el flag personal no libera al usuario — se interviene en el grupo, en el tab Grupos.',
      subject: 'Identidad',
      lastSeenAt: 'Última confirmación',
      enrollmentPending: 'Pendiente',
      orphanChip: 'Huérfano',
      orphanDirectoryMiss: 'La identidad ya no está en el directory',
      orphanRealmRemoved: 'El realm fue eliminado de TVirt',
      orphanedAt: 'Huérfano desde',
      directoryUuid: 'UUID en el directory',
      externalTitle: 'Enrollments externos',
      externalEmpty: 'Aún ningún enrollment externo — nace en el primer acceso de una identidad de directory con la obligación de MFA.',
      orphanHelp:
        'Un enrollment huérfano nunca se borra solo: es material de seguridad — queda para la auditoría y, si la identidad reaparece en el directory, reencuentra su factor. La única salida es el restablecimiento administrativo.',
      visibilityHint: 'Los enrollments externos residen en la raíz del clúster: solo los ve quien tiene user.read sobre el árbol entero.',
      orphanResetHint:
        'La fila huérfana se elimina definitivamente: ya nadie la reclama. Si la identidad reaparece en el directory, repetirá el enrollment desde cero.',
      enforcingTitle: 'Grupos que imponen la MFA',
      enforcingSubtitle:
        'El ancla de la obligación para las identidades externas es el grupo: sus mapeos de realm dicen a qué población de directory llega. El enrollment externo nace en el primer acceso del usuario obligado.',
      enforcingEmpty: 'Ningún grupo impone la MFA — la obligación se activa en el grupo, desde el tab Grupos.',
      enforcingError: 'No se pudieron cargar los grupos que imponen la MFA'
    }
  },
  realms: {
    title: 'Realms de autenticación',
    createTitle: 'Crear realm',
    editTitle: 'Editar realm',
    name: 'Realm',
    nameHint: 'El dominio que los usuarios escriben tras la @ (example.com) — inmutable tras la creación',
    nameImmutableHint: 'El nombre del realm queda estampado en cada sesión y en cada línea de audit que lo haya nombrado — renombrarlo reescribiría la historia',
    kind: 'Tipo',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC y SAML llegan con los próximos rounds — hoy un realm es un directory LDAPv3',
    kindCategory: 'Tipo de realm',
    kindSelectHint: 'Seleccione el tipo de directory contra el que este realm autenticará.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Username y contraseña verificados con un bind en un directory LDAPv3 — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Single sign-on desde el browser delegado a un identity provider OpenID Connect — llega con los próximos rounds.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Single sign-on corporativo con aserciones SAML 2.0 — llega con los próximos rounds.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Habilitado',
    urls: 'Servidores del directory',
    urlsHint: 'Una URL ldap:// o ldaps:// por línea (1–8), probadas en orden — failover, nunca balanceo',
    startTls: 'StartTLS',
    verifyCertificate: 'Verificar el certificado',
    cleartextWarning: 'Sin ldaps:// o StartTLS la contraseña de bind cruza la red en claro — aceptable en laboratorio, nunca en producción.',
    noVerifyWarning: 'Una sesión TLS no verificada no autentica a nadie: desactive la verificación solo contra un directory que no pueda arreglar.',
    caCertificate: 'Certificado CA (PEM)',
    caCertificateHint: 'Bundle CA opcional fijado para el handshake TLS/StartTLS de este realm; vacío lo quita',
    caCertificatePinned: 'Fijado',
    connectTimeout: 'Timeout (segundos)',
    connectTimeoutHint: 'Plazo por URL de conexión y petición (1–60); al vencer se prueba la URL siguiente',
    bindDn: 'Bind DN',
    bindDnHint: 'El service account que ejecuta la búsqueda del usuario; vacío = search bind anónimo (rechazado por AD)',
    anonymousBind: 'Search bind anónimo',
    bindCredential: 'Contraseña de bind (keystore)',
    bindCredentialHint: 'Una entrada usernamePassword del keystore con la contraseña de bind — el secreto nunca vive en el realm',
    bindCredentialNone: 'Ninguna (bind anónimo)',
    bindCredentialEmpty: 'Ninguna entrada usernamePassword en el keystore — cree una en Sistema > Credenciales para la contraseña de bind.',
    baseDn: 'Base DN',
    baseDnHint: 'El subárbol desde el que parte la búsqueda del usuario (DC=example,DC=com)',
    userFilter: 'Filtro de usuario',
    userFilterHint: '%u se sustituye por la parte local del login, con escape RFC 4515; los directories no-AD típicamente quieren (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'Atributo memberOf',
    memberOfAttributeHint: 'Leído una sola vez, al login — los grupos no mapeados se ignoran, el anidamiento no se resuelve',
    uuidAttribute: 'Atributo UUID',
    uuidAttributeHint: 'El UUID inmutable en el realm (objectGUID en AD, entryUUID en OpenLDAP) — estampado en el audit junto a usuario@realm',
    displayNameAttribute: 'Atributo del nombre mostrado',
    displayNameAttributeHint: 'Usado para saludar al usuario; en su defecto se usa el nombre de login',
    sudoHint: 'Las escrituras en los realms están protegidas por sudo: un realm es una puerta de entrada a la plataforma',
    deleteBody: 'Los mapeos de grupos del realm se van con él; las sesiones que autenticó siguen vivas hasta caducar — un realm borrado simplemente ya no admite a nadie.',
    tabConnection: 'Conexión',
    tabDirectory: 'Directory',
    testTitle: 'Probar conexión',
    testHint: 'Una sonda de configuración, nunca una autenticación: se conecta, hace el bind con el service account y — con un username — ejecuta el filtro de usuario.',
    testUsername: 'Nombre de usuario (opcional)',
    testUsernameHint: 'Una parte local sobre la que ejecutar el filtro de usuario — 1 coincidencia es la respuesta sana',
    testRun: 'Ejecutar prueba',
    testError: 'No se pudo ejecutar la sonda',
    testReachable: 'Directory alcanzable, bind de servicio aceptado',
    testUnreachable: 'Directory NO alcanzable',
    matchedOne: 'El filtro de usuario encontró exactamente 1 entrada — la respuesta sana.',
    matchedNone: 'El filtro de usuario no encontró ninguna entrada: el filtro o el base DN está equivocado.',
    matchedMany: 'El filtro de usuario encontró {count} entradas: no es selectivo, y los logins serían ambiguos (rechazados).',
    mappingsPointer: 'A qué corresponde un grupo externo es una propiedad del grupo TVirt (sus mapeos de realm): el punto de verdad vive en el tab Grupos.',
    mappingsPointerLink: 'Abrir el tab Grupos',
    rootHomeHint: 'Las identidades de un realm externo viven en la raíz del clúster, nunca en un vDC: los permisos se asignan donde hacen falta, con delegaciones — sobre el grupo o directamente sobre el usuario, exactamente como para los nativos.'
  },
  credentials: {
    title: 'Credenciales',
    createTitle: 'Crear credencial',
    editTitle: 'Editar credencial',
    kind: 'Tipo',
    kindUsernamePassword: 'Username y contraseña',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (identidad Ceph)',
    kindHintUsernamePassword: 'Inmutable. Para los storages CIFS/SMB — la cuenta de mount cuyo secreto usa el worker en el momento del mount.',
    kindHintIscsiChap: 'Inmutable. Para la autenticación CHAP iSCSI — username = nombre CHAP, secret = secreto CHAP.',
    kindHintNvmeDhchap: 'Inmutable. Para el DH-HMAC-CHAP de NVMe over Fabrics — secret = el blob DHHC-1:xx:…; el username es solo una etiqueta.',
    kindHintCephx: 'Inmutable. Para los clients Ceph — username = nombre del client (client.…), secret = la clave base64.',
    kindImmutableHint: 'El tipo es inmutable tras la creación — cambiarlo significa una credencial nueva.',
    username: 'Nombre de usuario',
    usernameChap: 'Nombre CHAP',
    usernameNvme: 'Etiqueta',
    usernameCephx: 'Nombre del client',
    usernameHint: 'Cuenta opcional a la que pertenece el secreto',
    usernameHintChap: 'El nombre CHAP con el que se autentica el initiator',
    usernameHintNvme: 'No usada por el transporte — una etiqueta libre para sus apuntes',
    usernameHintCephx: 'El nombre del client cephx — el prefijo client. se tolera',
    secret: 'Secreto',
    secretHint: 'Solo escritura: usado por los consumidores, nunca más mostrado.',
    secretHintNvmeDhchap: 'Solo escritura: el secreto DH-HMAC-CHAP del host en la forma canónica DHHC-1:xx:… — usado por los consumidores, nunca más mostrado.',
    secretHintCephx: 'Solo escritura: la clave cephx base64 — usada por los consumidores, nunca más mostrada.',
    secretEditHint: 'Deje vacío para no cambiar el secreto — rellenarlo lo rota.',
    createdAt: 'Creada',
    inUseError: "'{name}' está referenciada por la configuración de un storage — desconéctela allí primero.",
    nameHint: 'Minúsculas, cifras y guiones (DNS-1123); única por scope',
    rotateTitle: 'Rotar secreto',
    rotateHint: 'Solo escritura: el nuevo secreto sustituye al almacenado — los consumidores lo usarán en el próximo mount.',
    tabSecrets: 'Secretos',
    tabCertificates: 'Certificados',
    tabAuthorities: 'Autoridades de certificación',
    certificatesTitle: 'Certificados',
    authoritiesTitle: 'Autoridades de certificación',
    caCreateTitle: 'Nueva CA',
    certCreateTitle: 'Nuevo certificado',
    caMode: 'Origen',
    caModeGenerate: 'Generar con TVirt',
    caModeImport: 'Importar (clave + certificado)',
    certMode: 'Origen',
    certModeIssue: 'Emitir desde una CA del keystore',
    certModeImport: 'Importar (clave + certificado)',
    issuingCa: 'CA emisora',
    issuingCaHint: 'El certificado nace en el scope de la CA, con el parent registrado',
    noCasHint: 'Ninguna CA en el keystore — genere o importe una primero en el tab CA',
    commonName: 'Common name (CN)',
    commonNameCaHint: 'El subject de la CA: letras, cifras, espacio, punto, guion bajo, guion',
    commonNameCertHint: 'OpenVPN identifica los clients por el CN — manténgalo único por CA',
    days: 'Validez (días)',
    daysCaHint: '1–7300 días; 3650 (10 años) es el default',
    daysCertHint: '1–3650 días; 365 es el default',
    keyType: 'Tipo de clave',
    keyTypeHint: 'EC P-256 es el default; RSA para consumidores legacy',
    usage: 'Uso',
    usageClient: 'Client (clientAuth)',
    usageServer: 'Server (serverAuth)',
    usageHint: 'El extended key usage para el que se emite el certificado',
    san: 'Nombres alternativos (SAN)',
    sanHint: 'Separados por coma; los IP literales se vuelven entradas IP:, el resto DNS:',
    keyPem: 'Clave privada (PEM)',
    keyPemHint: 'Solo escritura: custodiada en el keystore, nunca más mostrada',
    certPem: 'Certificado (PEM)',
    certPemHint: 'El certificado público que se empareja con la clave',
    certPemCaHint: 'El certificado CA que se empareja con la clave (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Emisor',
    parentCa: 'CA emisora',
    parentCaImported: 'Importado — emitido fuera de TVirt',
    serial: 'Serial',
    fingerprint: 'Fingerprint (SHA-256)',
    validFrom: 'Válido desde',
    validUntil: 'Válido hasta',
    expiry: 'Caducidad',
    expired: 'Caducado',
    expiresInDays: 'Caduca en {days} d',
    revoked: 'Revocado',
    revokedAtLabel: 'Revocado el',
    revokeTitle: 'Revocar certificado',
    revokeAction: 'Revocar',
    revokeWarning: 'La revocación es definitiva: el serial entra en la CRL de la CA emisora y cada consumidor que rechaza los certificados revocados (OpenVPN el primero) rechazará este. No existe un-revoke.',
    exportPem: 'Exportar PEM',
    exportChain: 'Exportar bundle de cadena',
    exportCrl: 'Exportar CRL',
    materialImmutableHint: 'El material X.509 es inmutable — reemita o reimporte',
    caInUseError: "'{name}' aún tiene certificados emitidos vivos (o un storage la referencia) — revóquelos o elimínelos primero."
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Colocación, disponibilidad y afinidad — dónde corren las VM del clúster y si deben estar encendidas',
    loadError: 'El panel Proximity necesita el store de clúster — el estado de la flota no es alcanzable ahora',
    config: {
      title: 'Configuración',
      subtitle: 'Política de colocación a nivel de clúster',
      save: 'Guardar',
      saveError: 'La configuración ha sido rechazada',
      strategy: 'Estrategia de selección',
      strategy_leastUsedResources: 'Menos recursos usados',
      strategy_leastVms: 'Menos VM',
      strategy_random: 'Aleatoria',
      strategyLeastUsedResourcesHint: 'Entre los candidatos válidos, el nodo con más RAM usable restante (total observado − reserva host − VM encendidas), compromiso vCPU como desempate. Determinista a igualdad de datos.',
      strategyLeastVmsHint: 'Entre los candidatos válidos, el nodo con menos VM encendidas; los empates se resuelven por nombre. Determinista a igualdad de datos.',
      strategyRandomHint: 'Uniformemente aleatoria entre los candidatos válidos.',
      liveness: 'Umbral de vitalidad de los nodos (segundos)',
      livenessHint: 'Un miembro silencioso más allá del umbral es inalcanzable: excluido de la colocación y — si no está en mantenimiento — considerado muerto por el decider HA, que lo cerca y reinicia sus VM HA en otro lugar.',
      decider: 'Decider HA',
      deciderNone: 'aún no elegido'
    },
    nodesTitle: 'Nodos',
    nodesSubtitle: 'Vitalidad y capacidad empírica — RAM usable = total − base − comprometida',
    nodeCol: 'Nodo',
    stateCol: 'Estado',
    ramCol: 'RAM (total − base − comprometida)',
    usableCol: 'Usable',
    vmsCol: 'Carga',
    neverSeen: 'nunca visto',
    freshChip: 'alcanzable',
    staleChip: 'inalcanzable',
    attestedChip: 'atestiguado apagado',
    ramFormula: 'total − base − comprometida',
    haTitle: 'Alta disponibilidad',
    haSubtitle: 'Las VM con flag HA están "siempre encendidas": TVirt las reinicia tras cada stop no pedido — mismo nodo con backoff, otro nodo cuando el suyo muere (solo storage compartido).',
    haNone: 'Ninguna VM lleva aún el flag HA — habilítelo aquí o en el detalle de la VM.',
    haVmCol: 'Máquina virtual',
    haStateCol: 'Estado',
    haRestartsCol: 'Reinicios HA',
    haLastEventCol: 'Último evento',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'El cambio HA ha sido rechazado',
    rules: {
      title: 'Reglas de afinidad',
      createTitle: 'Nueva regla de proximidad',
      editTitle: 'Editar regla',
      nameHint: 'Minúsculas, cifras y guiones (etiqueta DNS)',
      vms: 'Máquinas virtuales',
      vmsHint: 'Al menos dos VM — la regla vincula dónde corren unas respecto de otras',
      type: 'Tipo',
      affinity: 'Afinidad (juntas)',
      antiAffinity: 'Anti-afinidad (separadas)',
      typeAffinityHint: 'Las VM deben correr en el MISMO nodo.',
      typeAntiAffinityHint: 'Las VM deben correr en nodos DISTINTOS — la clásica pareja HA.',
      mode: 'Modo',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Las violaciones rechazan la operación (arranque, migración, failover) con un error parlante.',
      modeSoftHint: 'Preferencia, nunca bloqueante: una colocación en violación procede con un aviso visible.',
      satisfied: 'Colocación',
      satisfiedYes: 'respetada',
      satisfiedNo: 'violada',
      violations: 'Violaciones',
      noViolations: 'Ninguna'
    },
    events: {
      title: 'Eventos HA',
      subtitle: 'El diario de la disponibilidad — reinicios, fencing, failovers y los saltos honestos',
      none: 'Todavía nada.',
      when: 'Cuándo',
      kind: 'Evento',
      target: 'Objeto',
      detail: 'Detalle',
      kindRestarted: 'reinicio HA',
      kindGaveUp: 'rendición (crash loop)',
      kindNodeAttested: 'nodo cercado',
      kindFailedOver: 'failover',
      kindNoCandidate: 'ningún candidato',
      kindStorageLocalSkip: 'saltada (storage local)',
      kindZombieFenced: 'zombie terminado'
    }
  }
}
